/* layal-hero-video.js (copie de preview/assets/hero-video.js) : vidéo transparente du hero, générée avec
 * Higgsfield / Seedance. Aucun maillage animé dans la page : le mouvement est lu par le navigateur, les six
 * déclinaisons sont préencodées (assets/layal-placement-<couleur>-540-v2 et -1080-v2, .webm et .mov, ou adresses des
 * blocs « Couleur »).
 * Différence avec la maquette : sur Safari (WebKit), si la vidéo HEVC (.mov) manque ou échoue, on ne se rabat pas
 * sur le WebM (Safari n'en lit pas la transparence : fond noir) ; l'image détourée reste affichée.
 *
 * Chargement différé : au démarrage, seule l'image détourée du coloris est affichée (elle part avec la page, en
 * priorité haute). Aucune vidéo n'est demandée avant la fin du chargement de la page (événement load) suivie d'un moment
 * d'inactivité, ou avant le premier geste de la visiteuse (toucher, clic, touche, molette). Seule la vidéo du coloris
 * affiché part alors ; elle apparaît en fondu quand le navigateur peut la lire sans à-coup (canplaythrough, ou fichier
 * entièrement chargé). Un coloris choisi ensuite charge sa seule vidéo. Animations réduites (prefers-reduced-motion) ou
 * économie de données (navigator.connection.saveData) : aucune vidéo, l'image détourée reste.
 * Taille : version 540 px tant que l'écran en demande au plus SEUIL_HD pixels physiques (téléphones, tablettes en
 * portrait : 268 à 522 mesurés), sinon version 1080 px quand le coloris en a une (ordinateurs, téléphone à
 * l'horizontale). */
(function () {
  "use strict";
  // Côté de la vidéo à l'écran (pixels physiques) au-delà duquel on prend la version 1080 px.
  var SEUIL_HD = 600;
  // Premier geste : la vidéo part juste après, une fois appliqué le coloris éventuellement choisi par ce geste
  // (glissé, carte touchée), pour ne jamais télécharger la vidéo d'un coloris qu'on quitte.
  var DELAI_GESTE = 80;
  var GESTES = ["pointerup", "pointercancel", "touchend", "keydown", "wheel"];
  window.LayalSilhouette = function (racine, donnees) {
    var config = donnees.silhouette;
    var fichiers = config && config.videos;
    var visuel = racine.querySelector("[data-hc-visuel]");
    if (!fichiers || !visuel) return null;
    var reduit = window.matchMedia("(prefers-reduced-motion: reduce)");
    var courant = donnees.coloris[0], lecture = false, ecoule = 0, debut = performance.now();
    var jeton = 0, active = null, entrante = null, premier = true, touchee = false;
    // arme : la vidéo peut être chargée (fin du chargement puis inactivité, ou premier geste) ; programme : en attente.
    var arme = false, programme = false;
    var dureeVideo = config.dureeVideo || 10;
    var vitesse = Math.max(0.25, Number(config.vitesse) || 1);
    var boucle = config.boucle === true;
    // « imageFinale » (secondes de vidéo, avant accélération) : sans boucle, le geste se joue de 0 à cet
    // instant, puis la vidéo reste en pause sur cette image (maintien posé sur la tête, voile encore relevé).
    // Il se joue au chargement, puis de nouveau depuis 0 à chaque choix de coloris. Absent : dernière image.
    var imageFinale = Math.min(dureeVideo, Number(config.imageFinale) > 0 ? Number(config.imageFinale) : dureeVideo);
    // Geste terminé (ou non joué : animations réduites, lecture refusée) : imageFinale jusqu'au prochain choix.
    var fige = !boucle && reduit.matches;
    // Sans boucle, choix de coloris en attente : la nouvelle vidéo se précharge en pause sur sa première image,
    // puis remplace l'ancienne et rejoue le geste depuis 0 dès qu'elle est prête (voir charger()).
    var relance = false;
    // Lecture automatique refusée une fois par le navigateur : plus de relance, coloris directement sur imageFinale.
    var lectureRefusee = false;
    var produit = document.createElement("div");
    produit.className = "hc__objet-scene";
    while (visuel.firstChild) produit.appendChild(visuel.firstChild);
    visuel.appendChild(produit);
    var scene = document.createElement("div");
    scene.className = "hc__video-scene";
    scene.setAttribute("aria-hidden", "true");
    visuel.appendChild(scene);
    var bouton = document.createElement("button");
    bouton.type = "button";
    bouton.className = "hc__voir-porte verre";
    bouton.setAttribute("data-hc-voir-porte", "");
    bouton.textContent = "Voir le geste";
    bouton.hidden = true;
    visuel.appendChild(bouton);
    racine.addEventListener("pointerdown", function () { touchee = true; }, { capture: true, passive: true });
    racine.addEventListener("keydown", function () { touchee = true; }, true);

    function secondes() {
      if (fige) return imageFinale;
      var temps = Math.max(0, (ecoule + (lecture ? performance.now() - debut : 0)) * vitesse / 1000);
      return boucle ? temps % dureeVideo : Math.min(imageFinale, temps);
    }
    // Dernière image lue : fin de la vidéo avec boucle, imageFinale sans boucle.
    function finDe(video) {
      var fin = Math.max(0, (video.duration || dureeVideo) - 0.04);
      return boucle ? fin : Math.min(fin, imageFinale);
    }
    function relanceEnAttente() { return relance && !reduit.matches && !lectureRefusee; }
    // Sans boucle : le geste est joué, la vidéo affichée reste sur imageFinale (celle en chargement aussi, sauf
    // relance en attente : elle reste sur sa première image ; celle en fondu de sortie garde son image).
    function figer() {
      if (boucle || fige) return;
      fige = true;
      synchroniserVideo(active, true);
      synchroniserVideo(entrante, true);
      libelle();
    }
    // Sans boucle : pause pile sur imageFinale. « timeupdate » est trop espacé pour une lecture accélérée,
    // on vérifie donc à chaque image tant que la vidéo joue.
    function guetter(video) {
      if (boucle || video.enGuet) return;
      video.enGuet = true;
      requestAnimationFrame(function tour() {
        // Une vidéo remplacée (en fondu de sortie) ne fige plus rien.
        if (video.paused || fige || (video !== active && video !== entrante)) { video.enGuet = false; return; }
        if (video.currentTime >= finDe(video) - 0.01) { video.enGuet = false; figer(); return; }
        requestAnimationFrame(tour);
      });
    }
    function libelle() {
      bouton.textContent = secondes() > 0.3 ? "Revoir le geste" : "Voir le geste";
      bouton.setAttribute("aria-label", "Voir le voile se soulever et le maintien épouser la tête, coloris " + courant.nom);
    }
    function synchroniserVideo(video, forcer) {
      if (!video || video.readyState < 1) return;
      // Relance en attente : la vidéo qui se précharge reste en pause sur sa première image (le premier
      // positionnement retire aussi l'affiche) ; le geste repartira de 0 quand elle sera prête.
      if (video === entrante && relanceEnAttente()) {
        video.pause();
        if (!video.auDepart || video.currentTime > 0.05) { video.auDepart = true; video.currentTime = 0; }
        return;
      }
      var duree = video.duration || dureeVideo;
      var fin = finDe(video);
      var cible = boucle ? secondes() % duree : Math.min(secondes(), fin);
      video.playbackRate = vitesse;
      video.loop = boucle && !reduit.matches;
      // Animations réduites : sans boucle, directement imageFinale (le geste n'est pas joué).
      if (reduit.matches) cible = !boucle || secondes() > 0 ? fin : 0;
      // On ne cherche pas une image à chaque frame : seule une vraie pause,
      // reprise, nouvelle couleur ou relance corrige la position du lecteur.
      var ecart = Math.abs(video.currentTime - cible);
      if (boucle && !reduit.matches) ecart = Math.min(ecart, Math.abs(duree - ecart));
      if (forcer || ecart > 0.22) video.currentTime = cible;
      if (lecture && !reduit.matches && (boucle || cible < fin)) {
        var p = video.play();
        if (p && p.catch) p.catch(function (e) {
          if (video !== active && video !== entrante) return;
          bouton.hidden = false;
          bouton.textContent = "Lire l’animation";
          // Lecture automatique refusée (ex. économie d'énergie sur iOS) : sans boucle, on montre
          // directement imageFinale plutôt que le maintien encore à côté de la tête (aussi pour les
          // coloris choisis ensuite : plus de relance).
          if (e && e.name === "NotAllowedError") { lectureRefusee = true; figer(); }
        });
        guetter(video);
      } else video.pause();
    }
    function retirer(video) { if (video) { video.pause(); video.removeAttribute("src"); video.load(); video.remove(); } }
    // Pixels physiques du côté de la vidéo à l'écran : vidéo carrée, contenue (object-fit: contain) dans la scène.
    function besoinPx() {
      var r = scene.getBoundingClientRect ? scene.getBoundingClientRect() : null;
      return r ? Math.min(r.width, r.height) * (window.devicePixelRatio || 1) : 0;
    }
    function charger(c) {
      var fichier = fichiers[c.id];
      if (!fichier) {
        // Photo fournie : une vidéo du coloris précédent ne doit jamais rester visible.
        jeton += 1;
        retirer(entrante); entrante = null;
        retirer(active); active = null;
        produit.classList.remove("hc__objet-scene--remplace");
        bouton.hidden = true;
        return;
      }
      var version = ++jeton;
      retirer(entrante); entrante = null;
      // HEVC avec alpha pour WebKit ; VP9 avec alpha pour Chromium / Firefox.
      // Tous les navigateurs iOS utilisent WebKit, y compris Chrome, Firefox et Edge.
      // iPadOS peut se présenter comme un Mac ; les points tactiles permettent de le reconnaître.
      var appleMobile = /iP(hone|ad|od)/.test(navigator.userAgent) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
      var webkit = appleMobile ||
        (/Safari/.test(navigator.userAgent) && !/Chrome|Chromium|Edg|OPR/.test(navigator.userAgent));
      // Version 1080 seulement si l'écran en a besoin et si le coloris en a une (sinon, la seule adresse du bloc).
      var hd = besoinPx() > SEUIL_HD;
      var webm = (hd && fichier.webmHd) || fichier.webm;
      var hevc = (hd && fichier.hevcHd) || fichier.hevc;
      if (webkit && !hevc) {
        // Safari sans vidéo HEVC pour cette couleur : image détourée, pas de vidéo (voir en-tête).
        retirer(active); active = null;
        produit.classList.remove("hc__objet-scene--remplace");
        bouton.hidden = true;
        return;
      }
      var source = webkit ? hevc : webm;
      var video = document.createElement("video");
      video.className = "hc__video";
      video.muted = true;
      video.defaultMuted = true;
      video.defaultPlaybackRate = vitesse;
      video.playbackRate = vitesse;
      video.loop = boucle && !reduit.matches;
      video.playsInline = true;
      video.setAttribute("playsinline", "");
      video.setAttribute("muted", "");
      // Pas d'affiche : la vidéo reste invisible (opacité 0) jusqu'à ce qu'elle soit lisible, une affiche ne serait
      // jamais vue et coûterait un téléchargement de plus.
      video.preload = "auto";
      video.setAttribute("data-video-coloris", c.id);
      var repliEssaye = false;
      video.src = source;
      scene.appendChild(video);
      entrante = video;
      video.addEventListener("loadedmetadata", function () { if (version === jeton) synchroniserVideo(video, true); }, { once: true });
      // Fondu seulement quand la lecture peut se faire sans à-coup : assez de données pour aller au bout
      // (canplaythrough, readyState 4) ou fichier entièrement chargé.
      var LISIBLE = ["canplay", "canplaythrough", "progress"];
      function lisible() {
        if (version !== jeton) return;
        var b = video.buffered, d = video.duration;
        var complet = d > 0 && b && b.length === 1 && b.start(0) <= 0.05 && b.end(0) >= d - 0.1;
        if (video.readyState < 4 && !complet) return;
        LISIBLE.forEach(function (type) { video.removeEventListener(type, lisible); });
        montrer();
      }
      LISIBLE.forEach(function (type) { video.addEventListener(type, lisible); });
      function montrer() {
        // Relance : la vidéo, prête sur sa première image, remplace l'ancienne puis rejoue le geste depuis 0.
        var rejouer = relanceEnAttente();
        relance = false;
        if (!rejouer) synchroniserVideo(video, false);
        var ancienne = active;
        active = video; entrante = null;
        video.classList.add("est-active");
        if (ancienne) {
          // Relance : l'ancienne vidéo (figée ou en plein geste) s'efface immobile sur l'image où elle est remplacée.
          if (rejouer) ancienne.pause();
          ancienne.classList.remove("est-active");
          setTimeout(function () { retirer(ancienne); }, reduit.matches ? 0 : 700);
        }
        produit.classList.add("hc__objet-scene--remplace");
        racine.classList.add("hc--avec-silhouette");
        bouton.hidden = false;
        libelle();
        if (premier) {
          premier = false;
          // Une URL de coloris conserve la couleur choisie pendant le geste.
          // Sans boucle, le geste se joue dès que la vidéo est prête, même après un premier contact.
          // Vidéo au cadre de l'image (hero du voile, departAZero) : l'image fixe est la 1re image de la vidéo ;
          // la boucle repart donc de 0 à sa première apparition (même avec le défilement en cours), pour que le
          // fondu image -> vidéo se fasse sur la même image, et non au milieu du geste.
          if ((!lecture || config.departAZero === true) && (!touchee || !boucle) && !fige && !reduit.matches) rejouer = true;
        }
        // Horloge remise à 0 et lecture lancée par la démonstration (hero-couleurs.js).
        if (rejouer) { fige = false; racine.dispatchEvent(new CustomEvent("hc:demonstration")); }
      }
      video.addEventListener("timeupdate", function () {
        // Filet de sécurité de guetter() (onglet en arrière-plan, horloge en avance sur la vidéo).
        if (!boucle && !fige && (video === active || video === entrante) && video.currentTime >= finDe(video) - 0.01) figer();
        libelle();
      });
      video.addEventListener("error", function () {
        if (version !== jeton) return;
        if (!repliEssaye && !webkit && source !== webm) {
          repliEssaye = true;
          video.src = webm;
          video.load();
          return;
        }
        retirer(video); entrante = null;
        retirer(active); active = null;
        produit.classList.remove("hc__objet-scene--remplace");
        bouton.hidden = true;
      });
    }

    // ---------- Chargement différé ----------
    // Vidéo permise : ni animations réduites, ni économie de données (Chrome Android ; absente de Safari).
    function videoPermise() {
      var connexion = navigator.connection;
      return !reduit.matches && !(connexion && connexion.saveData === true);
    }
    function oublierGestes() {
      GESTES.forEach(function (type) { window.removeEventListener(type, surGeste, true); });
    }
    // Premier chargement : la vidéo du coloris affiché à cet instant, et seulement elle.
    function armer() {
      if (arme || !videoPermise() || racine.isConnected === false) return;
      arme = true;
      oublierGestes();
      charger(courant);
    }
    function surGeste() {
      oublierGestes();
      setTimeout(armer, DELAI_GESTE);
    }
    // Après l'événement load : au premier moment d'inactivité (Safari, sans requestIdleCallback : une seconde).
    function apresChargement() {
      if (typeof window.requestIdleCallback === "function") window.requestIdleCallback(armer, { timeout: 2000 });
      else setTimeout(armer, 1000);
    }
    function programmer() {
      if (programme || arme || !videoPermise()) return;
      programme = true;
      GESTES.forEach(function (type) { window.addEventListener(type, surGeste, { capture: true, passive: true }); });
      if (document.readyState === "complete") apresChargement();
      else window.addEventListener("load", apresChargement, { once: true });
    }
    // Animations réduites activées en cours de visite : plus aucune vidéo, l'image détourée revient.
    function desarmer() {
      arme = false;
      programme = false;
      oublierGestes();
      jeton++;
      retirer(entrante); entrante = null;
      retirer(active); active = null;
      produit.classList.remove("hc__objet-scene--remplace");
      racine.classList.remove("hc--avec-silhouette");
      bouton.hidden = true;
    }

    bouton.addEventListener("click", function () {
      if (!reduit.matches) fige = false; // « Revoir le geste » : rejoue une fois depuis le début
      racine.dispatchEvent(new CustomEvent("hc:demonstration"));
      // Cet appel direct conserve l'activation utilisateur sur les navigateurs
      // qui restreignent la lecture automatique, même pour une vidéo muette.
      synchroniserVideo(active, true);
    });
    var api = {
      tempsReprise: function () { return secondes() * 1000 / vitesse; },
      couleur: function (c, manuel) {
        courant = c;
        // Sans boucle, chaque choix de la visiteuse rejoue le geste depuis 0 avec la nouvelle couleur, puis
        // s'arrête de nouveau sur imageFinale. La nouvelle vidéo ne remplace l'ancienne (figée ou en plein geste)
        // qu'une fois prête ; en cas de choix rapides, seul le dernier est chargé. Animations réduites ou lecture
        // refusée : la nouvelle couleur s'affiche directement sur imageFinale.
        relance = !!manuel && !boucle;
        // Avant le premier chargement (fin du chargement de la page ou premier geste), le coloris est seulement retenu.
        if (arme) charger(c);
        // Avec boucle, la nouvelle couleur reprend au même instant de la boucle et le choix relance la démonstration.
        if (manuel && boucle) racine.dispatchEvent(new CustomEvent("hc:demonstration"));
        libelle();
      },
      synchroniser: function (joue, temps) {
        lecture = joue && !reduit.matches;
        ecoule = temps;
        debut = performance.now();
        synchroniserVideo(active, false);
        synchroniserVideo(entrante, false);
        libelle();
      }
    };
    reduit.addEventListener("change", function () {
      ecoule = secondes() * 1000 / vitesse;
      if (reduit.matches) { lecture = false; fige = !boucle; }
      debut = performance.now();
      synchroniserVideo(active, true);
      // Désactivées : la vidéo du coloris affiché revient (au prochain moment d'inactivité ou geste).
      if (reduit.matches) desarmer();
      else programmer();
    });
    programmer();
    return api;
  };
})();
